import { NgModule } from '@angular/core';
import { Routes, RouterModule } from "@angular/router";
import { extract } from "app/core/i18n/i18n.service";
import { Route } from "app/core/route/route.service";
import { LoanRepaymentComponent } from './loan-repayment/loan-repayment.component';
import { LoanForeclosureComponent } from './loan-foreclosure/loan-foreclosure.component';
import { LoanCheckReversalComponent } from './loan-checkreversal/loan-checkreversal.component';
import { CurrenciesResolver } from 'app/home/resolvers/ currencies-resolver.service';

const routes: Routes = [
  Route.withShell([
    {
      path: "home/loans/repayment",
      component: LoanRepaymentComponent,
      data: { title: extract("Préstamos"), breadcrumb: "Pago de préstamos" },
      resolve: {
        supportedCurrencies: CurrenciesResolver
      }
    },
    {
      path: "home/loans/foreclosure",
      component: LoanForeclosureComponent,
      data: { title: extract("Préstamos"), breadcrumb: "Cancelación de préstamos" },
      resolve: {
        supportedCurrencies: CurrenciesResolver
      }
    },
    {
      path: "home/loans/cancelrepaymentwithcheck",
      component: LoanCheckReversalComponent,
      data: { title: extract("Préstamos"), breadcrumb: "Cancelación de Cheques" },
      resolve: {
        supportedCurrencies: CurrenciesResolver
      }
    }           
  ]),
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoanTransactionsRoutingModule { }
